import React, { useRef, useState, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import checkmark_empty from '../../icons/checkmark_empty.png'
import checkmark_full from '../../icons/checkmark_full.png'
import classes from './index.module.css'
import ExplicitTag from '../../GeneralComponents/ExplicitTag'
export default function SongGridItem({ song, onClick }) {
  const hasLyrics = song.has_lyrics
  const feelsCount = song.feels_count
  const isPublished = song.is_published

  const titleRef = useRef(null)

  const [isTruncated, setIsTruncated] = useState(false)

  useLayoutEffect(() => {
    if (!song?.is_explicit) return

    const checkOverflow = () => {
      const el = titleRef.current
      if (el) {
        const isOverflowing =
          el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
        setIsTruncated(isOverflowing)
      }
    }

    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => window.removeEventListener('resize', checkOverflow)
  }, [song?.name, song?.is_explicit])

  return (
    <div
      className={classes.container}
      onClick={() => {
        onClick(song)
      }}
    >
      <div className={classes.imageWrapper}>
        <img className={classes.image} src={song?.image?.url} />
      </div>
      <div className={classes.songDetailsWrapper}>
        {isTruncated ? (
          <div className={classes.songNameWrapper}>
            <p className={classes.songTitle} ref={titleRef}>
              {song?.name}
            </p>
            {song?.is_explicit && <ExplicitTag size="small" />}
          </div>
        ) : (
          <p className={classes.songTitle} ref={titleRef}>
            {song?.name} {song?.is_explicit && <ExplicitTag size="small" />}
          </p>
        )}

        <div className={classes.artistAvatarNameWrapper}>
          {song.artist.image.url ? (
            <img className={classes.avatar} src={song?.artist?.image?.url} />
          ) : (
            <div className={classes.emptyAvatarWrapper}>
              <p className={classes.emptyAvatarLetter}>
                {song?.artist?.name.charAt(0).toUpperCase()}
              </p>
            </div>
          )}
          <p className={classes.artistName}>{song?.song_artist_name || song?.artist?.name}</p>
        </div>
        {song?.track && (
          <span className={classes.statusText}>Track {song?.track}</span>
        )}

        <p className={classes.feelsCount}>
          {!feelsCount || feelsCount === 0 ? 0 : feelsCount} Feels
        </p>

        {hasLyrics ? (
          <div className={classes.verifiedWrapper}>
            <img
              width="24"
              height="24"
              src={song.is_sync_verified ? checkmark_full : checkmark_empty}
            />
            <span className={classes.statusText}>Sync Verified</span>
          </div>
        ) : (
          <div className={classes.statusPlateWrapper}>
            <span className={classes.statusPlateText}>Needs Lyrics</span>
          </div>
        )}
        {!isPublished ? (
          <div className={classes.unpublished}>Unpublished</div>
        ) : null}
      </div>
    </div>
  )
}

SongGridItem.propTypes = {
  song: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}
